import moment from 'moment';

export default class GeneratedPackage {
  constructor(data) {
    this.Name = data.Name;
    this.SizeBytes = data.SizeBytes;

    if (data.CreatedAt !== undefined) {
      this.CreatedAt = data.CreatedAt === null ? null : moment.utc(data.CreatedAt);
    }
  }

  getFormattedCreatedAt() {
    return this.CreatedAt ? this.CreatedAt.local().format('L LTS') : '—';
  }
}
